import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../variables/api";
import { Card, Grid } from "@material-ui/core";
import { CardHeader, Input } from "reactstrap";
import CardBody from "../../Components/Card/CardBody";
import "./Addticket.css";
import img1 from "../../assets/undraw_Preferences_re_49in.png";
import Button from "../../Components/Button";
import { Link } from "react-router-dom";
import {
  Progress,
  Modal,
  ModalHeader,
  ModalFooter,
  Form,
  ModalBody,
} from "reactstrap";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Translate } from "src/utils/Translate";
interface ITicketData {
  subject: string;
  description: string;
  department: string;
  attachements: any;
}
interface IAttachment {
  id: string;
  name: string;
  file: File;
}

function Addticket(props: any) {
  const [ticketData, setTicketData] = useState<ITicketData>({
    subject: "",
    description: "",
    department: "",
    attachements: [],
  });
  const [departmentData, setDepartmentData] = useState<any>([]);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [count, setCount] = useState(0);
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState<any>(null);
  const [progress, setProgress] = useState(0);
  const [attachments, setAttachments] = useState<any>([]);

  const t = new Translate();
  const addAttachement = (e: any) => {
    e.preventDefault();
    ticketData.attachements.push({ id: `attachment-${count}`, file: null });
    setAttachments([...ticketData.attachements]);
    setCount(count + 1);
  };
  const handleRemoveattachment = (id: any) => {
    let index = ticketData.attachements.findIndex((a: any) => a.id === id);
    ticketData.attachements.splice(index, 1);
    setTicketData((prevState) => ({
      ...prevState,
      attachements: ticketData.attachements,
    }));
  };
  console.log(ticketData);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const value = e.target.value;

    setTicketData((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const name = e.target.name;
    const value = e.target.value;

    setTicketData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleChangeAttachement = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: any
  ) => {
    const name = e.target.name;
    let attachements = [...ticketData.attachements];
    let index = attachements.findIndex((a: any) => a.id === id);
    if (e.target.files === null) return;
    if (name === attachements[index].id) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      attachements[index].file = selectedFile;
    }
    setTicketData((prevState) => ({
      ...prevState,
      attachements: attachements,
    }));
  };
  console.log(ticketData.attachements);
  useEffect(() => {
    axios.get(`${BASE_URL}/tickets/ticketutils.php`).then((res: any) => {
      setDepartmentData(res.data.data.departments);
    });
  }, []);
  useEffect(() => {
    console.log(document.getElementById("file"));
    ticketData.attachements?.forEach((element: any) => {
      console.log(element);
      if (element.file == null) {
        document.getElementById(element.id)?.click();
      }
    });
    console.log(attachments);
  }, [attachments]);

  const handleSubmitTicket = (e: React.FormEvent) => {
    e.preventDefault();
    Swal.showLoading();
    const formData = new FormData();
    Object.entries(ticketData).forEach(([key, value]) =>
      Array.isArray(value)
        ? value.forEach((attachment) => {
            formData.append(attachment.id, attachment.file);
          })
        : formData.append(key, value)
    );
    setShow(true);
    const res = axios
      .post(`${BASE_URL}/tickets/addticket.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setTicketData((prevstate) => ({
          ...prevstate,
          subject: "",
          description: "",
          department: "",
          attachements: [],
        }));
        setCount(0);

        Swal.fire(t.translate("Ticket Added Successfully"), "", "success").then(
          () => {
            navigate("/");
          }
        );
      })
      .catch((e) => {
        let ee = e as any;

        Swal.fire(
          ee?.response?.data.msg ||
            t.translate("Failed to Add Check Internet Connection"),
          "",
          "error"
        );
      });
    // setAttachments((prevState: any) => [...prevState, res.data.data]);
  };

  return (
    <div>
      <Link
        style={{ marginTop: "2%" }}
        to="/"
        className="btn btn-secondary mb-3"
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </Link>
      <Card>
        <p className="p">{t.translate("Adding a New Ticket")}</p>
        <CardBody md={12} sm={12} xs={12}>
          <Form onSubmit={handleSubmitTicket}>
            <Grid container md={12} sm={12} xs={12}>
              <Grid style={{ height: "100%" }} item md={6} sm={12} xs={12}>
                <img
                  style={{ width: "100%", marginTop: "9%", marginLeft: "5%" }}
                  src={img1}
                  alt="ticket booth"
                />
              </Grid>

              <Grid style={{ marginTop: "5%" }} item md={6} sm={12} xs={12}>
                <Grid container md={11} sm={12} xs={12}>
                  <Grid item md={12} sm={12} xs={12}>
                    <label>{t.translate("Subject")}</label>
                    <Input
                      required
                      type="text"
                      value={ticketData.subject}
                      name="subject"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
                <Grid container md={11} sm={12} xs={12}>
                  <Grid
                    style={{ marginTop: "2%" }}
                    item
                    md={12}
                    sm={12}
                    xs={12}
                  >
                    <label>{t.translate("Department")}</label>
                    <Input
                      required
                      type="select"
                      className="form-select"
                      value={ticketData.department}
                      name="department"
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        {t.translate("Select Department")}
                      </option>
                      {departmentData?.map((d: any) => (
                        <option key={d.id} value={d.id}>
                          {d.department}
                        </option>
                      ))}
                    </Input>
                  </Grid>
                </Grid>
                <Grid container md={11} sm={12} xs={12}>
                  <Grid
                    style={{ marginTop: "2%" }}
                    item
                    md={12}
                    sm={12}
                    xs={12}
                  >
                    <label>{t.translate("Description")}</label>
                    <textarea
                      required
                      value={ticketData.description}
                      style={{ width: "100%" }}
                      name="description"
                      onChange={handleChangeTextArea}
                    />
                  </Grid>
                </Grid>
                <Grid container md={11} sm={12} xs={12}>
                  <Grid item md={12} sm={12} xs={12}>
                    <Button
                      style={{ marginLeft: "0px" }}
                      className="btn btn-primary my-4"
                      onClick={(e: any) => {
                        addAttachement(e);
                      }}
                    >
                      {t.translate("Add Attachment")}
                    </Button>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <th>{t.translate("Attachment")}</th>
                          <th>{t.translate("Actions")}</th>
                        </thead>
                        <tbody>
                          {ticketData.attachements?.map(
                            (at: any, index: any) => {
                              return (
                                <tr key={at.id}>
                                  <td>
                                    <Input
                                      type="file"
                                      name={at.id}
                                      id={at.id}
                                      onChange={(e: any) =>
                                        handleChangeAttachement(
                                          e,
                                          `attachment-${index}`
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    <button
                                      className="btn btn-danger"
                                      style={{ margin: "auto" }}
                                      onClick={() =>
                                        handleRemoveattachment(at.id)
                                      }
                                    >
                                      {t.translate("Remove")}
                                    </button>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Grid>
                </Grid>

                <Grid container md={12} sm={12} xs={12}>
                  <Grid item md={12} sm={12} xs={12}>
                    <button
                      className="btn btn-primary"
                      style={{ marginLeft: "0" }}
                      type="submit"
                    >
                      {t.translate("Submit")}
                    </button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
}

export default Addticket;
